import React from "react"
import PropTypes from "prop-types"
import { Checkbox, Typography, FormControlLabel } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  label: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: 15,
    },
  },
  checkbox: {
    paddingLeft: 0, // Remove left padding from checkbox
  },
}))

const CustomCheckbox = ({
  label,
  checked,
  onChange,
  ...props
}) => {
  const classes = useStyles()

  // Handle change event
  const handleChange = (e) => {
    onChange(e.target.checked)
  }

  // If no label, render only the checkbox with no extra spacing
  if (!label) {
    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        color="primary"
        className={classes.checkbox}
        {...props}
      />
    )
  }

  // Compact inline layout for checkbox + label
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={handleChange}
          color="primary"
          className={classes.checkbox}
          {...props}
        />
      }
      label={
        <Typography className={classes.label} variant="body1">
          {label}
        </Typography>
      }
      labelPlacement="end"
      style={{ marginRight: 0, marginLeft: 0 }}
    />
  )
}

CustomCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default CustomCheckbox